import type { NewsCategoriesByType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoriesByType";
import type NewsSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsSignalFilters";
import createNewsUISignalNameBuilder from "app/pages/sales-intelligence/sub-modules/signals/services/ui-signals/news/newsUISignalNameBuilder";

import type UISignal from "../../../models/view/UISignal";
import type UISignalDeps from "../../../models/view/UISignalDeps";
import type UISignalFactory from "../UISignalFactory";

type FactoryDependencies = Omit<Readonly<UISignalDeps<NewsSignalFilters>>, "newsCategories"> & {
    readonly newsCategories: Readonly<NewsCategoriesByType>;
};

const newsUISignalFactory: UISignalFactory<NewsSignalFilters> = {
    createUISignal(deps: FactoryDependencies): Readonly<UISignal<NewsSignalFilters>> {
        const {
            newsCategories,
            numberOfAccounts,
            signal,
            template: { alias, description, name, signalSubType, timeframeConfig },
        } = deps;

        const nameBuilder = createNewsUISignalNameBuilder({ newsCategories });

        return {
            ...signal,
            numberOfAccounts,
            signalSubType,
            timeframeConfig,
            template: { alias, description, name },
            name: nameBuilder.buildName(signal),
            nameSegments: nameBuilder.buildNameSegments(signal),
            selectionTooltipLabels: nameBuilder.buildSelectionTooltipLabels(signal),
        };
    },
};

export default newsUISignalFactory;
